import { render, staticRenderFns } from "./MessageSend.vue?vue&type=template&id=5e39bbdf"
import script from "./MessageSend.vue?vue&type=script&lang=js"
export * from "./MessageSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports